import { NavArrowLeft } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconNavArrowLeft12Line = createIcon(NavArrowLeft, 12, "Line");
export const IconNavArrowLeft16Line = createIcon(NavArrowLeft, 16, "Line");
export const IconNavArrowLeft20Line = createIcon(NavArrowLeft, 20, "Line");
export const IconNavArrowLeft24Line = createIcon(NavArrowLeft, 24, "Line");
export const IconNavArrowLeft32Line = createIcon(NavArrowLeft, 32, "Line");
export const IconNavArrowLeft48Line = createIcon(NavArrowLeft, 48, "Line");
export const IconNavArrowLeft64Line = createIcon(NavArrowLeft, 64, "Line");
